import React, { useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import CheckIcon from "@material-ui/icons/Check";

import { colorPens } from "./utils/colors";
import TryNow from "./components/tryNow";

import useWeb3Forms from "@web3forms/react";

import "./Contact.css";

const Contact = () => {
    const [result, setResult] = useState(<><br /></>);

    const [isSuccess, setIsSuccess] = useState(false);
    const [readMore, setReadMore] = useState(false);

    React.useEffect(() => {
        // componentDidMount logic here
        return () => {
            // componentWillUnmount logic here
        };
    }, []);

    const onSubmit = async (event) => {
        event.preventDefault();
        setResult("Sending....");
        const formData = new FormData(event.target);

        formData.append("access_key", "60dae045-0551-494c-9336-424d9eeabb42");

        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData,
        });

        const data = await response.json();

        // for debugging
        // const data = {
        //     success: true
        //     // success: false,
        //     // message: "Error sending form. Please try again later. Thank you.",
        // };

        if (data.success) {
            // setResult("Form Submitted Successfully");
            setResult("");
            alert(
                "Your message has been sent successfully. We’ll get back to you shortly. Thank you!"
            );
            // event.target.reset();
            window.history.replaceState(null, '', '/');
            window.location.href = "/";
        } else {
            console.log("Error", data);
            setResult(data.message);
        }
    };

    return (
        <Container fluid>
            <Row className="justify-content-center">
                <Col>
                    <h3 align="center">
                        <b>Connect With Us</b>
                    </h3>
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col>
                    <>
                        <div className="container_form mb-12">
                            {/* max-w-md mx-auto p-4"> */}
                            <form onSubmit={onSubmit}>
                                <div>
                                    <label for="name">Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="(required)"
                                        required
                                    />
                                </div>
                                <br />
                                <div>
                                    <label for="email">Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="(required)"
                                        required
                                    />
                                </div>
                                <br />
                                <div>
                                    <label for="subject">Subject</label>
                                    <input
                                        type="text"
                                        name="subject"
                                        placeholder="Subject of your inquiry"
                                    />
                                </div>
                                <br />
                                <div className="mb-6">
                                    <label for="message">Message</label>
                                    <textarea
                                        name="message"
                                        placeholder="How can we help you? (required)"
                                        required
                                    ></textarea>
                                </div>
                                <div>
                                    <span style={{ color: '#ff0000', fontWeight: 'bold', marginBottom: '12px' }}>{result}</span>
                                </div>
                                <button type="submit">Send Message</button>
                            </form>
                        </div>
                    </>
                </Col>
            </Row>
        </Container>
    );
};

export default Contact;
